import * as React from 'react';
import { buildInput } from 'app/utils/forms';
import { each } from 'lodash';

interface Props {
    label: string;
    onChange?: any;
    onKeyPress?: any;
    type: string;
    autoFocus?: boolean;
    value?: string;
    icon?: string;
    id?: string;
    ref?: any;
    options?: any;
};

export class StandardInput extends React.Component<Props, {}> {

	render() {
        const {
            label,
            onChange,
            onKeyPress,
            type,
            autoFocus,
            value,
            icon,
            id,
            ref,
            options
        } = this.props;

        if (type === "dropdown") {

            let optionJSX: JSX.Element[] = [];

            each(options, option => {
                const selected = option.value === value;

                optionJSX.push(
                    <option value={option.value} selected={selected}>
                        {option.label}
                    </option>
                );
            });

            return <span style={{display: 'block', marginBottom: '20px'}}>
                <span style={{display: 'block', marginBottom: '5px'}}>{label}</span>
                <div className="bp3-select .modifier">
                    <select onChange={(event) => {
                        if (onChange) {
                            onChange(event);
                        }
                    }}>
                        {optionJSX}
                    </select>
                </div>
            </span>
        }

        return buildInput(value ? value : "", icon ? icon : undefined, label, id ? id : "", type, ref, onChange, autoFocus, onKeyPress);
	}
}
